<template>
  <div>
    <div style="" class="p-2 py-4 m-0 top-wrapper shadow-sm">
      <div class="">
        <b-row>
          <b-col class="">
            <h3 class="m-0 p-0">
              <b-icon class="" variant="primary" :icon="availableFlags ? availableFlags[0].icon : 'calendar-range'"></b-icon>
              {{funnelName}}
            </h3>
            <small class="text-muted"
              >{{ uniqByMobile.length }} items found.</small
            >
          </b-col>
          <b-col class="justify-content-end">
            <div
              class="col-md-12 m-0 p-0"
            >
              <b-button-toolbar class="justify-content-end">
                <div class="mr-1">
                  <b-dropdown
                    id="dropdown-1"
                    variant="outline-primary"
                    text="Change Status"
                    class="m-md-2"
                    :disabled="selectedItem.length == 0"
                  >
                    <b-dropdown-item @click="openChangeStatusModal(data.flag, data.state)"
                      v-for="(data, index) in availableFlags" :key="index">
                      {{data.state}}
                      </b-dropdown-item
                    >
                  </b-dropdown>
                  <b-button
                    @click="openSmsModal"
                    v-b-tooltip.hover
                    title="Send SMS"
                    variant="outline-primary"
                    class="mr-2"
                    :disabled="selectedItem.length == 0"
                  >
                    <i class="fad fa-comment-alt"></i>
                  </b-button>
                  <b-button
                    v-b-modal.customer-details
                    v-b-tooltip.hover
                    title="Show Customer Details"
                    variant="outline-primary"
                    class="mr-2"
                    :disabled="selectedItem.length == 0"
                  >
                    <i class="fad fa-info-circle"></i>
                  </b-button>
                  <!-- <b-button
                    variant="outline-primary"
                    class="mr-2"
                    v-b-tooltip.hover.html="'Vehicle Details'"
                    @click="vehicleDetails"
                    :disabled="selectedItem.length == 0"
                  >
                    <i class="fad fa-motorcycle"></i>
                  </b-button> -->
                  <b-button
                    @click="generateTicket"
                    v-b-tooltip.hover
                    title="Generate Payment Ticket"
                    variant="outline-primary"
                    class="mr-2"
                    :disabled="selectedItem.length == 0"
                  >
                    <i class="fad fa-ticket"></i>
                  </b-button>
                <b-button
                    variant="outline-primary"
                    class="mr-2"
                    v-b-tooltip.hover.html="'Payment Calculator'" 
                    title="Payment Calculator"
                    v-b-modal.calculator
                >
                    <i class="fad fa-calculator"></i>
                </b-button>
                <b-button
                    variant="outline-primary"
                    class="mr-2"
                    v-b-tooltip.hover
                    title="Export To CSV"
                    v-b-modal.export
                >
                    <i class="fad fa-file-export"></i>
                </b-button>
                </div>
              </b-button-toolbar>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="col-md-12 m-0 p-0 my-4">
      <div class="col-md-12 m-0 p-0">
            <b-nav tabs>
              <b-nav-item :active="currentFlag == data.flag" @click="changeCurrentTab(data.flag)" v-for="(data, index) in availableFlags" :key="index">
                {{ data.state }}
                ({{data.count}})
              </b-nav-item>
            </b-nav>
            <b-row class="border border-top-0 m-0 p-0">
              <b-col md="12 py-4">
                  <div class="m-0 p-0 px-2" v-if="search || modelsFilterSelected || (fromFilter && toFilter)">
                    <p class="text-success m-0 p-0">Got {{dataByStatus.length}} entries out of {{uniqByMobile.length}} unique entries. {{percentage}}% of total funnel.</p>
                  </div>
              </b-col>
              <b-col md="2" class="pb-4">
                <b-card body-class="m-0 p-2" class="border-0 shadow-sm m-0 p-0">
                  <div class="mb-2">
                    <p class="text-muted p-1 m-0">Search</p>
                    <b-input v-model="search" style="font-size:12px" type="text" placeholder="booking id, customer name, phone etc"></b-input>
                  </div>
                  <div class="mb-2">
                    <p class="text-muted p-1 m-0">Filter Models</p>
                    <b-form-select style="font-size:12px" v-model="modelsFilterSelected">
                      <b-select-option :value="null">All</b-select-option>
                      <b-select-option v-for="(model, index) in modelsList" :key="index" :value="model.id">
                        {{model.name}}
                      </b-select-option>
                    </b-form-select>
                  </div>
                  <div class="mb-2">
                    <div class="d-flex justify-content-between m-0 p-1">
                      <p class="text-muted m-0 p-0">Date Range</p>
                      <p class="btn-link m-0 p-0" v-if="fromFilter && toFilter" @click="resetFilterDates">Reset</p>
                    </div>
                    <div>
                      <div><b-form-datepicker style="font-size:12px" id="example-datepicker" v-model="fromFilter" class="mb-2"></b-form-datepicker></div>
                      <div><b-form-datepicker style="font-size:12px" today-button id="example-datepicker" v-model="toFilter" :min="fromFilter" class="mb-2"></b-form-datepicker></div>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="m-0 p-1">
                      <p class="text-muted m-0 p-0">Limit</p>
                      <b-select style="font-size:12px" v-model="perPage">
                        <b-select-option value="10">10</b-select-option>
                        <b-select-option value="20">20</b-select-option>
                        <b-select-option value="40">40</b-select-option>
                        <b-select-option :value="dataByStatus.length">All</b-select-option>
                      </b-select>
                    </div>
                  </div>
                </b-card>
              </b-col>
              <b-col class="pb-4">
                <b-card class="border-0 shadow-sm">
                  <b-table
                    :busy="loading"
                    sticky-header
                    selectable
                    select-mode="single"
                    @row-selected="onRowSelected"
                    class="border-0"
                    hover
                    :items="dataByStatus"
                    :fields="fields"
                    id="my-table"
                    :per-page="perPage"
                    :current-page="currentPage"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                    <template #cell(customerName)="data">
                      <span v-b-tooltip.hover :title="data.item.comment">{{data.value}}</span>
                    </template>
                    <!-- <template #cell(registrationNumber)="data">
                      <span v-b-tooltip.hover
                        :title="data.item.modelName">{{data.value}}</span>
                    </template> -->
                    <template #cell(customerMobile)="data">
                      <a
                        v-b-tooltip.hover
                        :title="
                          checkActiveStatus(data.item.activeStatus).description
                        "
                        class="px-2 py-1 p-0"
                        v-bind:style="{
                          background: checkActiveStatus(data.item.activeStatus).color,
                          'border-radius': '10px'
                        }"
                        style="text-decoration:none;color:white"
                        @click="callKnowlarity(data.value)"
                        >{{ data.value }}
                      </a>
                    </template>
                    <!-- <template #cell(endDate)="data">
                        {{data.value}} <span style="font-size:10px" class="text-muted">({{data.item.expiredDays}} days ago)</span>
                    </template>
                    <template #cell(totalPenalty)="data">
                      <span v-b-tooltip.hover.html="`<div class='text-left'> Daily Penalty: ₹${data.item.perDayPenalty} <br> Rental Penalty: ₹${data.item.bookingPenalty} </div>`">{{data.value}}</span>
                    </template> -->
                  </b-table>
                  <div class="my-5 text-center">
                    <p class="my-5 text-muted" v-if="dataByStatus.length == 0">No data found, try changing the filter.</p>
                  </div>
                </b-card>
                <div class="mt-4" v-if="dataByStatus.length > perPage">
                  <div class="">
                    <b-pagination
                      class=""
                      aria-controls="my-table"
                      v-model="currentPage"
                      :total-rows="dataByStatus.length"
                      :per-page="perPage"
                      align="right"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          <!-- </b-tab> -->
        <!-- </b-tabs> -->
      </div>
    </div>
    <b-modal
      hide-footer
      ref="changeStatusModal"
      scrollable
      id="send-sms"
      size="xl"
      title="Change status"
    >
      <changeFlag
        :metaData="changeStatusMetaData"
        :id="changeStatusId"
      ></changeFlag>
    </b-modal>
    <b-modal
      centered
      scrollable
      size="xl"
      ref="send-sms"
      title="Send SMS"
      hide-footer
    >
      <sms :metaData="sendSmsMetaData" :id="sendSmsId"></sms>
    </b-modal>
    <b-modal
      centered
      scrollable
      size="xl"
      ref="send-payment-link"
      title="Send SMS"
      hide-footer
    >
      <sendPaymentLink
        :id="selectedItem.length > 0 ? selectedItem[0].customer : null"
      ></sendPaymentLink>
    </b-modal>
    <b-modal
      ref="payTicketModal"
      centered
      scrollable
      :title="
        `Generate ticket for ${
          selectedItem.length > 0
            ? selectedItem[0].customerName
            : null
        }`
      "
      hide-footer
    >
      <paymentRetieval
        :bookingId="selectedItem.length > 0 ? selectedItem[0].bookingId : null"
      ></paymentRetieval>
    </b-modal>
    <b-modal id="customer-details" hide-footer hide-header centered>
      <customerDetails :id="selectedItem.length > 0 ? selectedItem[0].customer : null"></customerDetails>
    </b-modal>
    <b-modal size="lg" centered ref="calculatorModal" id="calculator" scrollable title="Payment Calculator" hide-footer>
      <calculator></calculator>
    </b-modal>
    <b-modal size="md" centered ref="call-knowlarity" id="call-knowlarity" scrollable title="Make Call" hide-footer>
      <call-knowlarity :number="callNumber"></call-knowlarity>
    </b-modal>
    <b-modal hide-footer ref="export" scrollable  id="export" size="xl" title="Export Data to CSV">
      <exportToCsv :data="dataByStatus"></exportToCsv>
    </b-modal>
  </div>
</template>

<script>
import * as _ from "lodash";
import flags from "../../../Inventory/flags.json";
import responsivenessData from "../../../Inventory/responsiveness";
import moment from 'moment'
import {eventBus} from '../../../main'

export default {
  data() {
    return {
      callNumber: null,
      search: '',
      fromFilter: null,
      toFilter: null,
      newBookingData: [],
      currentFlag : 0,
      funnelName: "New Booking",
      modelsFilterSelected: null,
      sendSmsId: null,
      sendSmsMetaData: null,
      changeStatusMetaData: null,
      changeStatusId: null,
      changeStatusModal: false,
      currentPage: 1,
      perPage: 10,
      openToolsPanel: false,
      selectedItem: [],
      loading: true,
      flags: flags,
      responsivenessData: responsivenessData,
      status: [],
      fields: [
        {
          key: "bookingId",
          label: "ID",
        },
        {
          key: "customerName",
          label: "Name"
        },
        {
          key: "deliveryType",
          label: "Delivery",
          formatter: value => {
            return value == 0 ? 'SelfPickup': 'Delivery'
          }
        },
        {
          key: "customerMobile",
          label: "Phone",
        },
        {
          key: "createdAt",
          label: 'Created',
          sortable: true,
          formatter: value => {
            return moment(value).format('lll')
          }
        },
        {
          key: "modelName",
          label: "Model"
        }
      ],
    };
  },
  created() {
    this.getData();
    this.getModels();
    eventBus.$on('new', ()=> {
      this.getData()
      this.$refs["changeStatusModal"].hide();
    })
  },
  watch: {
    uniqByMobile(){
        var newArray = []
        this.availableFlags.forEach(x=> {
          delete x.count
          newArray.push({
            count: this.getCount(x.flag), ...x
          })
        })
        this.flags = newArray
      },
      search(newValue) {
        if(newValue > 0) {
          this.perPage = this.newBookingData.length
        }
      }
  },
  methods: {
    callKnowlarity(number) {
      this.callNumber = number
      this.$refs["call-knowlarity"].show();
    },
    resetFilterDates () {
      this.fromFilter = null 
      this.toFilter = null
    },
    vehicleDetails(){
      this.$toasted.show("Feature will be available soon", { type: "success" }).goAway(2000);
    },
    getCount(flag) {
      return (this.uniqByMobile.filter(x => x.flagFormatted == flag)).length
    },
    changeCurrentTab(tab) {
      this.currentFlag = tab
    },
    onRowSelected(item) {
      if (item) {
        this.openToolsPanel = true;
      } else {
        this.openToolsPanel = false;
      }
      this.selectedItem = item;
    },
    async getData() {
      this.loading = true;
      try {
        var {data} = await this.$store.dispatch("get_new_bookings");
        this.newBookingData = data
        var allFilters = []
        this.availableFlags.forEach(x=> {
          if ( x.flag != 0)
          allFilters.push(x.flag)
        })
        this.newBookingData.map(d => {
          if (allFilters.includes(d.flag)) {
            d.flagFormatted = d.flag;
          } else {
            d.flagFormatted = 0;
          }
        })
      } finally {
        this.loading = false;
      }
    },
    getModels() {
      this.$store.dispatch("get_models");
    },
    getDateByNumber(n) {
      const dateNow = new Date();
      const newDate = new Date(dateNow);
      newDate.setDate(newDate.getDate() + n);
      return newDate;
    },
    checkStatusData(status) {
      return this.flags.find((x) => {
        return x.flag == status;
      });
    },
    checkActiveStatus(status) {
      var x = this.responsivenessData.find((x) => {
        return x.activeStatus == status;
      });
      return x ? x : { activeStatus: status, color: "red", description: "Not Defined" };
    },
    openChangeStatusModal(changeToFlag, funnel) {
      var selectedItem = this.selectedItem[0];
      this.changeStatusId = selectedItem.customer;
      var obj = {
        flag: changeToFlag,
        funnel: funnel,
        bookingId: selectedItem.id,
        dispatch: "get_new_bookings",
        event: 'new'
      };
      this.changeStatusMetaData = obj;
      this.$refs["changeStatusModal"].show();
      console.log(obj, this.changeStatusId);
    },
    openSmsModal() {
      this.sendSmsId = this.selectedItem[0].id;
      var obj = {
        mobile: this.selectedItem[0].mobile,
        Name: this.selectedItem[0].fName,
        Registration_Number: this.selectedItem[0].registrationNumber,
      };
      this.sendSmsMetaData = obj;
      this.$refs["send-sms"].show();
    },
    openSendPaymentLink() {
      this.$refs["send-payment-link"].show();
    },
    generateTicket() {
      this.$refs["payTicketModal"].show();
    }
  },
  computed: {
    percentage(){
      return (this.dataByStatus.length/this.uniqByMobile.length * 100).toFixed(1)
    },
    availableFlags: {
        get () { return this.flags.filter(x=> x.funnel === this.funnelName) }
    },
    modelsList() {
      return this.$store.state.models_list;
    },
    uniqByMobile() {
        return _.filter(_.uniqBy(this.newBookingData, "customerMobile"))
    },
    filterModel() {
      if(this.modelsFilterSelected) {
        return this.uniqByMobile.filter(x => {
          return x.model === this.modelsFilterSelected
        })
      } else {
        return this.uniqByMobile
      }
    },
    sortedByEndDate() {
      return _.orderBy(this.filterModel, "createdAt", 'desc');
    },
    filteredbydates() {
      var vm = this
      if (vm.fromFilter && vm.toFilter) {
        return _.filter(vm.sortedByEndDate, function(data) {
            var date = moment(data.createdAt).format("YYYY-MM-DD");
            return date >= vm.fromFilter && date <= vm.toFilter;
        });
      } else {
        return this.sortedByEndDate
      }
    },
    filterBySearchInput() {
      return this.filteredbydates.filter((post) => {
        return (
          post.customerName.toLowerCase().includes(this.search.toLowerCase()) ||
          post.bookingId.toLowerCase().includes(this.search.toLowerCase()) ||
          post.registrationNumber
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          post.customerMobile.toString().includes(this.search.toLowerCase())
        );
      });
    },
    dataByStatus() {
      return this.filterBySearchInput.filter(x=> {return x.flagFormatted == this.currentFlag })
    }
  },
};
</script>

<style>
.table th {
  border: 0 !important;
}
.top-wrapper {
  background: #ffffff;
}
</style>

